import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { authInstance } from "apis";
import Inquiry from "types/Inquiry";
import authAtom from "stores/auth";

const useInquiry = (projectId: number) => {
  const auth = useRecoilValue(authAtom);

  const fetcher = async () => {
    const { data } = await authInstance.get("inquiry", {
      params: {
        projectId,
      },
    });

    return data;
  };

  const { data: inquiries } = useQuery<Inquiry[]>(["inquiry"], fetcher, {
    enabled: auth.type === "company",
  });

  return inquiries;
};

export default useInquiry;
